import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PromoCode, PromoCodePricing } from 'app/shared/models/class/discount/discount';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DiscountService {

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getPromoCodeByClub(clubCode?: string): Observable<PromoCode[]> {
    return this.http.get<PromoCode[]>(`${environment.apiUrl}/PromoCode/${clubCode}`);
  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */

  addPromoCodeAdmin(promoCode: PromoCode) {
    return this.http.post(`${environment.apiUrl}/PromoCode`, promoCode);
  }

  addPromoCodeUser(promoCode: PromoCodePricing) {
    return this.http.post(`${environment.apiUrl}/PromoCode/PromoCodePricing`, promoCode);
  }

  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */

  updatePromoCode(promoCode: PromoCode) {
    return this.http.put(`${environment.apiUrl}/PromoCode`, promoCode);
  }

  /* -------------------------------------------------------------------------- */
  /*                                   DELETE                                   */
  /* -------------------------------------------------------------------------- */

  deletePromoCode(promoCodeKey: number) {
    return this.http.delete(`${environment.apiUrl}/promoCode/${promoCodeKey}`);
  }

}
